export default __webpack_public_path__ + "assets/images/2336015bb49d0fb23a3deb4883672fdd.png";